import { useState } from 'react';

import Image from '@cartwhl/ui/atoms/Image';
import Input from '@cartwhl/ui/atoms/Input';
import Text from '@cartwhl/ui/base/Text';
import Button from '@cartwhl/ui/input/Button';
import Modal from '@cartwhl/ui/molecules/Modal';

import { noticesStore, posingStore } from 'stores';

export default function RenderFeedbackModal({
  open,
  onOpenChange,
  sentiment,
  prompt,
  imageURL,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  sentiment: 'positive' | 'negative';
  prompt: string;
  imageURL?: string;
}) {
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);

  const submitFeedback = async () => {
    setLoading(true);
    await posingStore.setFeedback(sentiment, comment);
    setLoading(false);
    onOpenChange(false);
    noticesStore.success(`Your feedback has been received. Thank you!`);
  };

  return (
    <Modal
      title={`Report ${sentiment === 'negative' ? 'poor' : 'great'} render`}
      open={open}
      closeOnClickOutside={false}
      maxWidth={700}
    >
      <div className="mb-6 flex gap-6">
        {imageURL && (
          <Image
            className="max-h-[160px] w-auto max-w-[260px] rounded-lg"
            crossOrigin="anonymous"
            src={imageURL}
            alt="Rendered pose preview"
          />
        )}
        <div className="pt-2">
          <Text variant="studio/body/medium/md" as="h2">
            {prompt}
          </Text>
        </div>
      </div>
      <div>
        <Input
          as="textarea"
          name="pose-feedback"
          placeholder="Anything else we should know?"
          label="Additional comments (optional)"
          onChange={(e) => setComment(e.target.value)}
        />
      </div>
      <div className="mt-6 flex justify-end">
        <Button loading={loading} variant="primary" onClick={submitFeedback}>
          Done
        </Button>
      </div>
    </Modal>
  );
}
